import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import GeneralLogin from './GeneralLogin';
import withRouter from '../../components/withRouter';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
@inject('store')
@observer
class Login extends Component {
    state = {
        loading: true
    };

    async componentDidMount() {
        const {
            store: { login },
            searchParams
        } = this.props,

            // 根据 URL 查询参数初始化视图状态：forget/codeVerify/login 三种模式，默认 login
            modeFromUrl = searchParams.get('mode'),
            validModes = ['forget', 'codeVerify', 'login'];
        login.setMode(validModes.includes(modeFromUrl) ? modeFromUrl : 'login');

        // try {
        //     //获取租户第三方配置
        //     await login.getThirdConfig();
        // } catch (error) {
        //     console.error(error);
        // }

        // // 是否走外部登录
        // if (login.thirdConfig?.login_redirect === 2) {
        //     try {
        //         // eslint-disable-next-line
        //         const uri = new URL(login.thirdConfig?.login_redirect_web);
        //         return (window.location.href = login.thirdConfig?.login_redirect_web);
        //     } catch (err) {
        //         console.error(err);
        //     }
        // }

        if (searchParams.get('redirect')) {
            login.setRedirectUrl(window.location.search.replace('?redirect=', ''));
        }
        const isLogin = await login.checkLogin();
        if (isLogin) {
            return login.loginCallback();
        }
        await login.submitImproveInfoOrgidsFun();
        await login.getLoginCustomConfig();
        this.setState({
            loading: false
        });
    }

    render() {
        return <>{this.state.loading ? <GrtLoading /> : <GeneralLogin />}</>;
    }
}

export default withRouter(Login);
